<template>
    <transition name="fade" mode="out-in">
        <div v-if="resource.ready">
            <div class="card mb-3">
                <div class="card-title" v-once>
                    <span
                        >Продление аренды – #{{ entry.id }} ({{
                            entry.product.name
                        }})</span
                    >
                </div>

                <form class="spaced-y-4" @submit.prevent="submit">
                    <div class="flex -mx-2">
                        <date-field
                            class="w-1/2 px-2"
                            title="Окончание"
                            v-model="renewal.ends_at"
                            format="Y-m-d H:i:00"
                            :time="true"
                            displayFormat="H:i d.m.Y"
                            :errors="errors.ends_at"
                        />

                        <text-field
                            type="number"
                            class="w-1/2 px-2"
                            title="Доплата"
                            v-model="renewal.amount"
                            :errors="errors.amount"
                            required
                        />
                    </div>

                    <div class="flex -mx-2">
                        <select-field
                            class="w-1/2 px-2"
                            title="Счет"
                            label="name"
                            valueName="id"
                            :options="selects.accounts"
                            v-model="renewal.account_id"
                            :errors="errors.account_id"
                            :clearable="false"
                            required
                        />
                    </div>

                    <hr class="mb-3" />

                    <button :disabled="saving" class="btn btn-primary">
                        Отправить
                    </button>
                </form>
            </div>
        </div>
    </transition>
</template>

<script>
import ResourceForm from "@/components/Resource/ResourceForm";

export default {
    extends: ResourceForm,

    data() {
        return {
            resource: {
                name: "admin.billing.rentals",
                endpoint: "admin/billing/rentals",
            },

            renewal: {
                ends_at: moment().format("Y-M-D H:m:s"),
                amount: null,
                account_id: null,
            },

            selects: {
                accounts: [],
            },
        };
    },

    methods: {
        submit() {
            axios
                .post(
                    `/admin/billing/rentals/${this.entry.id}/renew`,
                    this.renewal
                )
                .then((response) => {
                    this.$message.success("Аренда продлена");

                    this.$router.push({
                        name: "admin.billing.rentals.edit",
                        params: {
                            id: this.entry.id,
                        },
                    });
                });
        },

        async fetchSelects() {
            await axios.get("/admin/assets/accounts/all").then((response) => {
                this.selects.accounts = response.data.data;

                this.renewal.account_id = this.selects.accounts[0].id;
            });
        },
    },

    mounted() {
        this.fetchSelects();
    },
};
</script>